export default __webpack_public_path__ + "static/media/Path 128.e802e5bb.svg";